/* eslint-disable no-prototype-builtins */

export default class Validate {
    static emailValidate = email => {
        const emailPattern = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*(\+[_a-z0-9-]+)?@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
        return typeof email === "string" && emailPattern.test(email);
    };

    static mountRawPhone = phone => {
        return phone.toString(10).replace(/[^\d]/g, "");
    };

    static validatePhoneNumber = phone => {
        //verifica os códigos de área
        const isValidCode = this.validateAreaCode(phone.substring(0, 2));

        //o primeiro dígito, desconsiderando o código de área, deve ser 9.
        const isFisrtDigitValid = phone[2] === "9";

        //o segundo dígito, desconsiderando o código de área, deve ser diferente de 0.
        const isSecondDigitValid = phone[3] !== "0";

        //todos os números não podem ser iguais
        const shortPhone = phone.substring(3, 11);
        const allEquals = shortPhone
            .split("")
            .every(number => number === shortPhone[0]);

        //o número de um telefone móvel deve ter 11 dígitos
        const sizeNumberValidate = phone.length === 11;

        return (
            sizeNumberValidate &&
            isValidCode &&
            isFisrtDigitValid &&
            isSecondDigitValid &&
            !allEquals
        );
    };

    static validateAreaCode = value => {
        return /(1[1-9])|(2[12478])|(3[1-578])|(4[1-9])|5[13-5]|6[1-9]|7[134579]|8[1-9]|9[1-9]/.test(
            value
        );
    };

    static isValidInput = (inputName, inputValue) => {
        let inputPattern;
        switch (inputName) {
            case "name":
                inputPattern = /^[a-zA-ZÀ-ú\d\n' '.!+-]+$/g;
                break;
            case "title":
                inputPattern = /^[a-zA-ZÀ-ú\d' '.!+-]+$/g;
                break;
            case "walletToken":
            case "clientId":
                inputPattern = /^[a-zA-Z\d-]+$/g;
                break;
            case "slug":
            case "parentSlug":
                inputPattern = /^[\w\d-.]+$/g;
                if (!inputValue) return true;
                break;
            case "weight":
            case "order":
                if (inputValue < 0 || Number.isNaN(Number(inputValue)))
                    return false;
                inputPattern = /^[\d]+$/g;
                break;
            case "clientSecret":
                inputPattern = /[a-zA-Z0-9]{8,}/g;
                break;
            case "organization":
                if (inputValue) return inputValue.length > 0;
                break;
            default:
                return false;
        }

        return Boolean(
            inputValue !== null &&
                inputValue !== undefined &&
                inputValue.toString().trim() &&
                inputPattern &&
                inputPattern.test(inputValue.toString().trim())
        );
    };

    static isEmpty = obj => {
        return obj && typeof obj === "object" && Object.keys(obj).length === 0;
    };

    static isValidTargetValue = targetKey => {
        return targetKey >= 1 && targetKey < 100;
    };

    static isValidIcon = base64 => {
        if (!base64) {
            return true;
        }
        return !base64.includes("data:image/svg+xml;base64");
    };

    static isValidRevision = (miniApp, input) => {
        if (input) {
            const inputValue = miniApp.revisions[0][input];
            const booleanValue = !(inputValue.length > 0);
            return !booleanValue;
        }
    };
    static isValidMiniappTarget = miniApp => {
        const result = miniApp.target && miniApp.target !== "no_opt";
        return result;
    };

    static getInvalidInputs = (miniApp, isEditScreen) => {
        const basicInputs = ["name", "title", "slug"];
        const editInputs = ["walletToken"];
        const registerInputs = ["type", "target"];
        let invalidInputs = [];
        const objectResult = {
            icon: Validate.isValidIcon(miniApp.icon),
            basicInputs: Validate.checkBasicInputs(miniApp),
            walletToken: Validate.isValidInput(
                "walletToken",
                miniApp.walletToken
            ),
            clientId:
                Validate.isCredentialValid(miniApp, "clientId") &&
                !isEditScreen &&
                miniApp.credential.clientId.length > 0,
            clientSecret:
                Validate.isCredentialValid(miniApp, "clientSecret") &&
                !isEditScreen &&
                miniApp.credential.clientSecret.length > 0,
            organization:
                !isEditScreen &&
                Validate.isValidInput(
                    "organization",
                    miniApp.organization.name
                ),
            url: !isEditScreen && Validate.isValidRevision(miniApp, "url"),
            version:
                !isEditScreen && Validate.isValidRevision(miniApp, "version"),
            target: !isEditScreen && Validate.isValidMiniappTarget(miniApp)
        };
        if (basicInputs) {
            invalidInputs.push(
                ...basicInputs.filter(
                    input => !Validate.isValidInput(input, miniApp[input])
                )
            );
        }

        for (let input in objectResult) {
            if (isEditScreen)
                editInputs.includes(input) &&
                    !objectResult[input] &&
                    invalidInputs.push(input);
            else
                registerInputs.includes(input) &&
                    !objectResult[input] &&
                    invalidInputs.push(input);
        }

        return invalidInputs;
    };

    static checkBasicInputs = miniApp => {
        const { name, title, slug } = miniApp;
        const basicProperty = { name, title, slug };

        let isValid = false;

        for (var property in basicProperty) {
            isValid = Validate.isValidInput(property, basicProperty[property]);
            if (!isValid) {
                return false;
            }
        }
        return isValid;
    };

    static checkNotBasicInputs = (form, isEditScreen) => {
        let fieldsToVerify = isEditScreen
            ? ["walletToken"]
            : ["clientId", "clientSecret"];

        for (let input in form) {
            let isVerifiableField = fieldsToVerify.indexOf(input) >= 0;
            if (
                isVerifiableField &&
                !Validate.isValidInput(input, form[input])
            ) {
                return false;
            }
        }
        return true;
    };

    static isCredentialValid = (miniApp, _credential) => {
        if (
            miniApp.credential &&
            ["clientSecret", "clientId"].indexOf(_credential) === -1
        )
            return false;

        if (!miniApp.credential || !miniApp.credential[_credential])
            return true;
        return (
            miniApp.credential &&
            miniApp.credential[_credential] &&
            Validate.isValidInput(_credential, miniApp.credential[_credential])
        );
    };

    static hasProperties = (object, propertyNames) => {
        if (Validate.isEmpty(object) || propertyNames.length === 0)
            return false;
        for (let property of propertyNames) {
            if (!object.hasOwnProperty(property)) return false;
        }
        return true;
    };

    static isValidSchemas = (schema, arrayKeys) => {
        if (Validate.isEmpty(schema) || arrayKeys.length === 0) return false;
        if (Object.keys(schema).length !== arrayKeys.length) return false;

        for (var key in schema) {
            if (arrayKeys.indexOf(key) === -1) return false;
        }

        return true;
    };
}
